import React, {Component} from 'react'
import ReactHtmlParser, {convertNodeToElement} from 'react-html-parser';
// import { isUrl, RoutePath } from './path';
// import {Link} from 'react-router-dom'
import PropTypes from 'prop-types';


const ignoredTags = [
    'object',
    'embed',
    'iframe',
    'script',
    'frameset',
    'applet',
    'link',
    'body',
    'html',
    'head',
];
const ignoredAttrs = ['formaction', 'srcdoc'];

let linkCounter = 0;

const transform = (node) => {
    if (node.type === 'tag') {
        if (node.attribs) {
            for(let attrName in node.attribs){
                if(ignoredAttrs.includes(attrName)){
                    console.warn(`Insecure attribute '${attrName}' removed from node '${node.name}'.`)
                    delete node.attribs[attrName]
                    continue;
                }

                // All onXXXX attribute will be removed
                if(/on[\w\d]+/.test(attrName)){
                    console.warn(`Insecure attribute '${attrName}' removed from node '${node.name}'.`)
                    delete node.attribs[attrName]
                    continue;
                }
            }
        }
        if(node.name === 'a'){
            // if(!isUrl(node.attribs.href)){
            //     let props = {
            //         // to: RoutePath(node.attribs.href),
            //     };
            //     if(node.attribs.id){
            //         props.id = node.attribs.id; 
            //     }
            //     if(node.attribs.target){
            //         props.target = node.attribs.target; 
            //     }
            //     if(node.attribs.class){
            //         props.className = node.attribs.class; 
            //     }
            //     return <Link key={`link-${linkCounter++}`} {...props}>{node.children.map( (child, index) => {
            //         return convertNodeToElement(child, index, transform)
            //     })}</Link>
            // }
        }
        if (ignoredTags.includes(node.name)) {
            console.warn(`Insecure node '${node.name}' ignored.`)
            return null;
        }
    }
}
;

/**
 * Render html tags without unsafe tags / attributes
 */
const renderHtml = (text = '') => {
    if(text === null) return null;
    return ReactHtmlParser(text, {
        transform
    })
}

export class HtmlContent extends Component {

    aTagCounter = 0;

    _linkClicked (e, node) {
        const {props} = this;
        // console.log('HtmlContent#linkClicked', e, node)

        // debugger;
        if(props.onLinkClicked){
            props.onLinkClicked(e, {url: node.attribs.href, title: node.attribs.title, class: node.attribs.class, target: node.attribs.target})
        }
    }
    transform (node){

        if(node.type === 'tag'){
            if(node.name === 'a'){

                    // For all absolute link tag element, use internal handler for trigger 
                // if(isUrl(node.attribs.href)){
                //     this.aTagCounter++;
                //     return <a key={`atag-${this.aTagCounter}`} href={node.attribs.href} target={node.attribs.target} title={node.attribs.title} className={node.attribs.class} onClick={(e)=> this._linkClicked(e, node)}>{node.children.map( (child, index) => {
                //         return convertNodeToElement(child, index, transform)
                //     })}</a>
                // }
            }
        }

        return transform(node);
    }
    render() {
        const {props} = this;
        return <div className="html-content">
            {props.text && (props.html ? ReactHtmlParser(props.text, {
                transform: this.transform.bind(this)
            }): props.text)}
        </div>
    }
}

HtmlContent.propTypes = {
    text: PropTypes.string.isRequired,
    html: PropTypes.bool,
    onLinkClicked: PropTypes.func,
}

HtmlContent.defaultProps = {
    text: '',
    html: true,
    onLinkClicked: null,
}
export default renderHtml;